<template>
  <v-container>
    <v-card class="dt-border pad-10" flat>
      <v-container class="pt-10">
        <v-row class="pa-5 mb-5">
          <div>
            <h2>Users</h2>
          </div>
          <v-spacer></v-spacer>
          <v-form class="d-flex" @submit.prevent="name ? reload() : ''">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              :clearable="true"
              rename
              v-model="name"
              placeholder="First name, last name or email"
            />
            <v-btn
              class="ml-5"
              @click="name ? reload() : ''"
              color="primary"
              depressed
              >Search</v-btn
            >
          </v-form>
          <v-spacer></v-spacer>
          <v-menu
            v-model="menu"
            style="box-shadow: none"
            :close-on-content-click="false"
            :close-on-click="true"
            :nudge-width="100"
            min-width="300"
            max-width="300"
            class="menu dt-border"
            offset-y
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                outlined
                rounded
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-filter-variant </v-icon>
                filter
              </v-btn>
            </template>
            <v-card class="pa-5" flat>
              <label for="">Status</label>
              <v-select
                :items="statusList"
                v-model="status"
                item-text="text"
                item-value="key"
                dense
                outlined
                return-object
              ></v-select>
              <label for="">Date</label>
              <br />
              <DateRangePicker v-model="dateRange" />
              <v-card-actions>
                <v-btn rounded depressed @click="reset">Reset</v-btn>
                <v-btn color="primary" @click="reload()" rounded depressed
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-row>
        <v-row class="pl-5">
          <div>
            <span
              v-if="details.total != 0 && this.loading == false"
              class="dt-orange white--text pa-2 rounded"
              >{{ details.total }} Users</span
            >
          </div>
          <v-spacer></v-spacer>
          <dtunes-pagination
            @reload="reload"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            :rows="rows"
            :limit="limit"
            :page="page"
            :totalPage="totalPage"
          />
        </v-row>
        <br /><br />
        <dtunes-loader :loading="loading"></dtunes-loader>
        <customer-card :details="details" />
        <dtunes-empty v-if="details.total == 0 && this.loading == false">
          <template v-slot:title> No registered user yet </template>
          <template v-slot:sub-title> </template>
        </dtunes-empty>
      </v-container>
      <!-- CUSTOMER CARDS  -->
    </v-card>
  </v-container>
</template>

<script>
// ========== IMPORT COMPONENTS =======
import CustomerCard from "../components/cards.vue";
import DtunesPagination from "@/components/dtunes-pagination.vue";
import DtunesLoader from "@/components/dtunes-loader.vue";
import DtunesEmpty from "@/components/dtunes-empty.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

// =========== IMPORT SERVICE =========
import { UsersService } from "@/services";
import { UserStatusEnum } from "@/enums";

export default {
  data: () => ({
    page: 1,
    limit: 20,
    details: {},
    name: "",
    loading: false,
    rows: [20, 50, 100],
    totalPage: 0,
    menu: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    statusList: [
      {
        text: "All",
        key: null,
      },
      {
        text: "Active",
        key: UserStatusEnum.Active,
      },
      {
        text: "Inactive",
        key: UserStatusEnum.Inactive,
      },
      {
        text: "Suspended",
        key: UserStatusEnum.Suspended,
      },
    ],
    status: {
      text: "All",
      key: null,
    },
  }),
  components: {
    CustomerCard,
    DtunesPagination,
    DtunesLoader,
    DtunesEmpty,
    DateRangePicker,
  },
  mounted() {
    this.getUsers();
  },
  computed: {},
  methods: {
    async getUsers() {
      try {
        let filter = {
          startDate: this.dateRange.startDate,
          endDate: this.dateRange.endDate,
          status: this.status.key
        };
        this.loading = true;
        const data = await UsersService.listUsers({
          page: this.page,
          limit: this.limit,
          filters: this.cleanUpFilter(filter),
          search: this.name,
        });
        this.details = data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
      this.totalPage = Math.ceil(this.details.total / this.limit);
    },
    async reload(value) {
      this.page = 1;
      if (value) {
        this.limit = value;
      }
      await this.getUsers();
      this.menu = false;
    },
    cleanUpFilter(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === "") {
          delete obj[key];
        }
      });
      let check = Object.keys(obj).length === 0;
      return check ? null : obj;
    },
    async pageChangeHandle(value) {
      switch (value) {
        case "next":
          this.page += 1;
          break;
        case "previous":
          this.page -= 1;
          break;
        default:
          this.page = value;
      }
      this.getUsers();
    },
    reset() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.status= this.statusList[0];
      this.getUsers();
      this.menu = false;
    },
  },
  watch: {
    name (value) {
      if (!value) {
        this.getUsers();
      }
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/Global/scss/variables.scss";
.customer-count {
  color: $Dtunes-text;
}
.dtunes-date-picker .vue-daterange-picker .form-control.reportrange-text {
  border: none;
  background: transparent;
  width: 100%;
  display: flex;
  align-items: center;
}

.dtunes-date-picker .vue-daterange-picker {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.daterangepicker .ranges li.active {
  color: var(--orange);
  background: unset;
}

.daterangepicker td.in-range {
  background-color: rgba(175, 105, 19, 0.3);
  border-color: transparent;
  color: #000;
  border-radius: 0;
}
.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: var(--orange);
  border-color: transparent;
  color: #fff;
}
.dtunes-date-picker {
  border: 2px solid #ebebeb;
  border-radius: 5px !important;
  font-size: 14px;
  height: 45px;
  margin-bottom: 20px;
  // width: 100%;
}
</style>